import { Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { AiOutlineClose } from "react-icons/ai";
import { FaBars } from "react-icons/fa";
import TaifurLogo from "../../assets/image/Taifur-logo2.svg";
import { toggleSwitch } from "../../feature/navToggle/navSlice";
import "./bars.scss";

const Bars = () => {
  const toggle = useSelector((state) => state.toggle.toggle);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleSwitch());
  };

  return (
    <div className="main-bar">
      <div className="bars-container">
        <div className="bars-btn">
          <Button onClick={handleToggle}>
            {toggle ? <AiOutlineClose size={20} /> : <FaBars size={20} />}
          </Button>
        </div>
        <div className="bar-logo">
          <img src={TaifurLogo} alt="Taifur Logo" />
        </div>
      </div>
    </div>
  );
};

export default Bars;
